$(function () {
    var body = $('body');
    var nav = $('.nav');
    var burger = $('.burger');
    var nav_trigger = $('.nav').find('ul li.menu-item-has-children > button');
    var mobile_trigger = $('.nav').find('ul li.menu-item-has-children > button');
    var megamenu = $('.Megamenu');
    var megamenu_trigger = $('.nav').find('ul li.menu-item-has-megamenu > button');
    var megamenu_child_trigger = $('.nav').find('.megamenuTrigger');
    var megamenu_close = $('.megamenuClose');
    var megamenu_parent = $('.megamenu-column-one');
    var megamenu_child = $('.megamenu-column-two');
    var break_point = 1200;
    var browser_width = window.innerWidth;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');
    var first_menu_item = nav_wrap.find('> .nav > ul.mainMenu > li:first-child > a, > .nav > ul.mainMenu > li:first-child > button');
    var nav_aux_last = $('.nav-aux').find('li:last-child a, li:last-child button');

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            if (browser_width < break_point) {
                nav_reset();
                burger.focus();
            } else {
                $('.menu-item-has-children').removeClass('__active');
                $('.menu-item-has-megamenu').removeClass('__active');
                $('.menu-item-has-megamenu button').attr('aria-expanded', false);
                body.removeClass('__blur');
            }
        }
    });

    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();

            burger.on('keydown', function (event) {
                if (event.key === 'Tab') {
                    event.preventDefault(); // Prevent default tabbing behavior
                    first_menu_item.focus(); // Redirect focus to the burger button
                }
            })

            nav_aux_last.on('keydown', function (event) {
                if (event.key === 'Tab') {
                    event.preventDefault(); // Prevent default tabbing behavior
                    burger.focus(); // Redirect focus to the burger button
                }
            })
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        nav.find('a, button').attr('tabindex', '-1');
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile __blur');
        nav.find('ul').removeClass('__active');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, div').removeClass('__active');
        megamenu.find('.__active .__left').removeClass('__active __left');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav.find('a, button').attr('tabindex', '0');
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    // set tabindex for menu links if user zooms in to 200%
    window.addEventListener("resize", function () {
        browser_width = window.innerWidth;  // Ensure updated browser width

        if ((window.devicePixelRatio >= 1.25 && browser_width < break_point) ||
            (window.devicePixelRatio >= 2 && browser_width >= break_point)) {
            body.addClass('__zoom-accessibility');
            initMenu();
        }

        else {
            body.removeClass('__zoom-accessibility');
            initMenu();
        }
    });
    
    function initMenu() {
        var browser_width = window.innerWidth;

         // nav dropdown on focus/keyboard navigation
        if ((browser_width >= break_point) && !body.hasClass('__zoom-accessibility')) {
            nav.find('a, button').attr('tabindex', '0');
            body.removeClass('__mobile');
            nav.find('ul').removeClass('__active');
            
            nav_trigger.off('click').on('click', function (event) {
                event.preventDefault();

                if ($(this).attr('aria-expanded') === 'true') {
                    $(this).attr('aria-expanded', 'false');
                    $(this).parent().removeClass('__active');
                    $(this).siblings('.megamenu-container').find('button').removeClass('__active');
                    body.removeClass('__blur');
                }
                else {
                    $('.menu-item-has-megamenu').removeClass('__active');
                    $('.megamenuTrigger, .megamenuContent').removeClass('__active');
                    $(this).attr('aria-expanded', 'true');
                    $(this).parent().addClass('__active');
                    $(this).siblings('.megamenu-container').find('button').addClass('__active');
                    $(this).parents('.menu-item').siblings('.menu-item-has-children').children('button').attr('aria-expanded', 'false');
                    $(this).parents('.menu-item').siblings('.menu-item-has-children').removeClass('__active');
                    body.addClass('__blur');
                }
            });

            megamenu_close.click(function (event) {
                $(this).parent().siblings(megamenu_trigger).attr('aria-expanded', false);
                $(this).parent().removeClass('__active');
                $(this).parent().parent(nav_trigger).removeClass('__active');
                $(this).siblings('.megamenu-container').find('button').removeClass('__active');
                body.removeClass('__blur');
            });

            $(document).on("click", function (event) {
                if ($(event.target).closest(".nav[aria-label='Primary']").length === 0) {
                    nav.find('.__active').removeClass('__active');
                    nav.find('[aria-expanded="true"]').attr('aria-expanded', false);
                    body.removeClass('__blur');
                }
            });

            megamenu_child_trigger.on("keydown", function (event) {
                if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
                    return; // Let default tab navigation happen
                }
                if (event.key === "Tab" || event.key === " ") {
                    event.preventDefault();
                    let $megamenu = $(this).closest(".megamenu");
                    let panelId = $(this).data("set");
                    let $panel = $megamenu.find(".megamenuContent[data-set='" + panelId + "']");
                    let hasTextOnly = $panel.find(".megamenu-nav-text").length > 0;
                    let $firstMenuItem = $panel.find("ul li:nth-child(2) a"); // Get the first link or button

                    if ($panel.length) {
                        $panel.attr("aria-expanded", "true");

                        if (hasTextOnly) {
                            focusNextTab(panelId); // If no focusable items, move to next tab
                        } else {
                            $firstMenuItem.focus(); // Move focus to first focusable element
                        }
                    }
                }
            });

            // Handle Tab navigation inside the panel
            $(".megamenuContent li:last-child a, .megamenuContent li:last-child button").on("keydown", function (event) {
                if (event.key === "Tab" && !event.shiftKey) {
                    event.preventDefault();
                    let tabId = $(this).closest(".megamenuContent").data("set"); // Get the current panel's data-set
                    let $tab = $(".megamenuTrigger[data-set='" + tabId + "']"); // Get the associated tab trigger
                    let $siblingLink = $tab.siblings("button"); // Check if the trigger has a sibling link

                    if ($siblingLink.length) {
                        $siblingLink.focus(); // If sibling link exists, focus it
                    } else {
                        focusNextTab(tabId); // Otherwise, move to next tab
                    }
                }
            });

            function activateTab(tabId) {
                let $newTab = $(".megamenuTrigger[data-set='" + tabId + "']");
                let $newPanel = $(".megamenuContent[data-set='" + tabId + "']");
                let $siblingLink = $newTab.siblings("a"); // Get sibling link

                if ($newTab.length && $newPanel.length) {
                    // Remove __active class from all tabs and panels
                    $(".megamenuTrigger").removeClass("__active").attr("aria-selected", "false");
                    $(".megamenuContent").removeClass("__active").attr("aria-expanded", "false");

                    // Activate the selected tab and panel
                    $newTab.addClass("__active").attr("aria-selected", "true").focus();
                    $newPanel.addClass("__active").attr("aria-expanded", "true");

                    // Check if the panel has focusable elements
                    let $menuItems = $newPanel.find("a, button");

                    if ($menuItems.length > 0) {
                        $menuItems.first().focus(); // Focus first item if available
                    } else if ($siblingLink.length) {
                        $siblingLink.focus(); // If no menu items, focus sibling link
                    } else {
                        focusNextTab(tabId); // Otherwise, go straight to next tab
                    }
                }
            }

            function focusNextTab(currentTabId) {
                let nextTabId = currentTabId + 1;
                let $nextTab = $(".megamenuTrigger[data-set='" + nextTabId + "']");
                let $siblingLink = $nextTab.siblings("button"); // Check if the next tab has a sibling link

                if ($nextTab.length) {
                    activateTab(nextTabId);
                } else if ($siblingLink.length) {
                    $siblingLink.focus(); // If next tab has a sibling link, focus it
                } else {
                    megamenu_close.focus();
                }
            }
        }

        if (browser_width < break_point) {
            nav.find('a, button').attr('tabindex', '-1'); 

            mobile_trigger.click(function (event) {
                if ($(this).parent().children('ul').length > 0) {
                    $(this).parent().children('ul').addClass('__active');
                    $(this).parent().children('ul').find('li:first-child a, li:first-child button').focus();
                }

                if ($(this).siblings('.megamenu').length > 0) {
                    $(this).parents('ul').removeClass('__active');
                    $(this).siblings(megamenu).addClass('__active');
                    $(this).siblings(megamenu).find('.megamenu-column-one .megamenu-nav-list').addClass('__active');
                    $(this).siblings(megamenu).find('.megamenu-column-one').addClass('__active');
                }
            });

            megamenu_trigger.click(function (event) {
                event.stopPropagation();
                $(this).parent().parent().addClass('__active');
                $(this).parent().parent().children('.menu-item-is-megamenu').addClass('__active');
                $(this).parent().siblings('.menu-item-is-megamenu').find('>div:first-child a, >div:first-child button').focus();
            });

            megamenu_child_trigger.click(function (event) {
                $(this).parent().parent().parent(megamenu_child).addClass('__left');
                $(this).parent().parent().parent(megamenu_child).siblings(megamenu_parent).addClass('__active');
            });

            // Disable root item link click
            $('.menu-item-has-children > a, .menu-item-has-megamenu .menu-item-has-megamenu-button> a, a.megamenu-link-has-children').click(function (event) {
                event.preventDefault();
            });
        }       

        $('.Megamenu').each(function (i, tab) {
            var tabRoot = $(this);
            var tabTrigger = '.megamenuTrigger';
            var tabContent = '.megamenuContent';
            var findTabTrigger = tabRoot.find(tabTrigger);
            var findTabContent = tabRoot.find(tabContent);
            var megamenu_trigger = $('.nav').find('ul li.menu-item-has-megamenu > button, ul li.menu-item-has-megamenu .menu-item-has-megamenu-button>a');

            // enable hover on desktop
            if (browser_width >= break_point) {
                $('.megamenu-item').mouseover(function (e) {
                    e.preventDefault();
                    var dataSet = $(this).find(tabTrigger).data('set');

                    tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
                    $(this).find(tabTrigger).attr('aria-selected', true).addClass('__active');

                    tabRoot.find(tabContent + '.__active').attr('aria-expanded', false).removeClass('__active');
                    tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');
                });

                $('.megamenu-item').keypress(function (e) {
                    e.preventDefault();
                    var dataSet = $(this).find(tabTrigger).data('set');

                    tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
                    $(this).find(tabTrigger).attr('aria-selected', true).addClass('__active');
                    $(this).siblings().find(megamenu).removeClass('__active');

                    tabRoot.find(tabContent + '.__active').attr('aria-expanded', false).removeClass('__active');
                    tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');
                });

                function activateDataSet(dataSet) {
                    findTabTrigger.eq(0).attr('aria-selected', true).addClass('__active');
                    findTabContent.eq(0).attr('aria-selected', true).addClass('__active');
                }

                // Activate data-set 1 when the menu opens
                megamenu_trigger.on('click', function () {
                    activateDataSet(1);
                });

                $(window).on('resize', function () {
                    activateDataSet(1);
                });
            }

            else {
                findTabTrigger.click(function (e) {
                    var dataSet = $(this).data('set');

                    tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
                    $(this).attr('aria-selected', true).addClass('__active');
                    megamenu_child.addClass('__active');
                    tabRoot.find(tabContent + '.__active').attr('aria-expanded', false).removeClass('__active');
                    tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').attr('aria-expanded', true).addClass('__active');
                });
            }

            findTabTrigger.click(function (e) {
                $(tabRoot).addClass('__active');
            });


            // mobile meganav tabs in progress
            if (browser_width < break_point) {
                findTabTrigger.click(function (e) {
                    $('.megamenu-column-one').removeClass('__active');
                });
            };

        });


        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }
        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });

            megamenu_child_trigger.click(function (event) {
                preventDefault();
            });
        }

        var view_all = $('.viewall');
        view_all.click(function (event) {
            event.stopPropagation();
        });

        var back_menu = $('.backto button');
        back_menu.click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            megamenu.removeClass('__active');
            megamenu_parent.removeClass('__active');
            $(this).closest('.menu-item.__active').removeClass('__active');

            if ($(this).parent().parent().hasClass("menu-item-is-megamenu")) {
                body.removeClass('__blur');
            }
        });

        var back_menu_mega = $('.backtomega button');
        back_menu_mega.click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            megamenu_child.removeClass('__active');
            $(this).closest(megamenu_child).siblings(megamenu_parent).removeClass('__left').addClass('__active');
            $(this).closest('.megamenuContent').removeClass('__active');
        });
    };

    
    initMenu();

    function debounce(func, wait) {
        let timeout;
        return function () {
            const context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    $(window).on('resize', debounce(function () {
        var browser_width = window.innerWidth;
        nav_reset();
        initMenu();
    }, 250));

});